import { Chapter, ChapterLesson, Course } from "@jelly/lesson";
import { useQuery } from "react-query";

import { courseProvider, progressProvider } from "../providers/local";
import { getChapters } from "../services/Utils";

interface UseCourseWelcomeResult {
  course?: Course;
  chapters?: Chapter[];
  firstLesson?: ChapterLesson;
}

export default function useCourseWelcomeController(courseId: string): UseCourseWelcomeResult {
  const queryCourse = useQuery(["queryCourse", courseId], () => courseProvider.get(courseId), {
    staleTime: 10 * 60 * 1000,
    keepPreviousData: true,
  });
  const queryLessonResults = useQuery(
    ["lessonResults", courseId],
    () => {
      return progressProvider.getCourseLessonResults(courseId);
    },
    {
      staleTime: 10 * 60 * 1000,
    }
  );

  const course = queryCourse.data;
  const firstLesson = course?.chapters[0].chapterLessons[0];
  const chapters = getChapters(course, queryLessonResults.data);

  return {
    course,
    chapters,
    firstLesson,
  };
}
